import { Controller } from "@hotwired/stimulus";

const iconSelector = "span";
const navContainerOpenModifier = "secondary-nav--open";

export default class extends Controller {
  static targets = ["navContainer", "toggleButton"];

  toggle() {
    this.navContainerTarget.classList.toggle(navContainerOpenModifier);

    document.querySelector("body").classList.toggle("u-hide-overflow");

    if (this.navContainerTarget.classList.contains(navContainerOpenModifier)) {
      this.toggleButtonTarget.querySelector(iconSelector).textContent = "close";
    } else {
      this.toggleButtonTarget.querySelector(iconSelector).textContent = "menu";
    }
  }
}
